import { useQuery } from '@tanstack/react-query';

import { useIsAdmin } from './hooks';
import { useFocusAdminState } from './state';

import {
  getCategoryByCountryCodeOptions,
  IntlCategoriesDto,
} from '@/_generated/api-clients/content';

/** Categories. */
export const useCategories = <TData = IntlCategoriesDto>(
  select?: (data: IntlCategoriesDto) => TData,
) => {
  const { selectedCountry } = useFocusAdminState('selectedCountry');
  const isAdmin = useIsAdmin();

  return useQuery({
    ...getCategoryByCountryCodeOptions({
      query: {
        isAdmin,
        country: selectedCountry.label,
      },
    }),
    enabled: isAdmin,
    select,
  });
};
